import { DateTime, Duration } from "../imports";
import { observatoryMetadata } from "../config";
import { getCurrentObservatoryName } from "../utils";

/**
 * Function to sit on a timer and update the clock node
 */
export function updateClock() {
  const observatoryName = getCurrentObservatoryName();
  const timezone = observatoryMetadata[observatoryName].TZInfo;
  const currentDateTime = DateTime.now().setZone(timezone);

  const timeContainer = document.getElementById("current-status-local-time");

  timeContainer.innerText = currentDateTime.toLocaleString(
    DateTime.TIME_24_WITH_SECONDS
  );
}

/**
 * Set up the clock panel for an observatory
 */
export function initializeClockForObservatory() {
  const observatoryName = getCurrentObservatoryName();
  const timezone = observatoryMetadata[observatoryName].TZInfo;
  updateClock();

  const timezoneString = timezone.replace("_", " ");
  const offsetString = getTimezoneOffset(timezone);
  const titleNodeText = `${timezoneString} (${offsetString})`;

  document.getElementById("current-status-local-time-title").innerText =
    titleNodeText;
}

/**
 * Get the UTC offset string for a timezone
 * @param {string} timezone - the luxon-compatible timezone as stored in obs config
 * @returns {string} - UTC+hh:mm
 */
function getTimezoneOffset(timezone) {
  const offsetMinutes = DateTime.now().setZone(timezone).offset;
  const offsetDuration = Duration.fromObject({ minutes: offsetMinutes });
  const offsetTimeString = offsetDuration.toFormat("h:mm");

  // manually include a '+' as necessary
  if (offsetTimeString[0] == "-") {
    return "UTC" + offsetTimeString;
  }
  return "UTC+" + offsetTimeString;
}
